module.exports = __webpack_public_path__ + "img/insta-2.e6dc8e1d.jpg";